import * as React from 'react';
import { Layout } from '../Layout';

import {
  useEstimationTargetProps,
  useAddressProps,
  useRoomNumberInputProps,
  useRoomsCountSelectorProps,
  useAreaInputProps,
  useHouseAreaInputProps,
  useLandAreaInputProps,
  useNewbuildingSectionProps,
  useSwitchComponentProps,
} from '../../hooks';
import { AddNewCardContainer } from '../AddNewCard';
import { useSaveSource } from '../../hooks/useSaveSource';

export const MyHomeContainer: React.FC = () => {
  useSaveSource();

  const estimationTargetProps = useEstimationTargetProps();
  const addressProps = useAddressProps();
  const roomNumberProps = useRoomNumberInputProps();
  const roomsCountSelectorProps = useRoomsCountSelectorProps();
  const areaProps = useAreaInputProps();
  const houseAreaProps = useHouseAreaInputProps();
  const landAreaProps = useLandAreaInputProps();
  const newbuildingSectionProps = useNewbuildingSectionProps();
  const switchProps = useSwitchComponentProps();

  return (
    <>
      <Layout
        estimationTargetProps={estimationTargetProps}
        addressProps={addressProps}
        roomsCountSelectorProps={roomsCountSelectorProps}
        areaProps={areaProps}
        roomNumberProps={roomNumberProps}
        houseAreaProps={houseAreaProps}
        landAreaProps={landAreaProps}
        newbuildingSectionProps={newbuildingSectionProps}
        switchProps={switchProps}
      />

      <AddNewCardContainer />
    </>
  );
};
